import { fork } from "redux-saga/effects";

function* watchPreloadedStockPageData() {}

export default [fork(watchPreloadedStockPageData)];
